'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import emptyFunction from 'react-utils/emptyFunction';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getHost } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const WIDTH = 918;
const PADDING_TOP_BOTTOM = 60;
function isSameHost() {
  return enviro.deployed('content-creator') || enviro.get('content-creator') === 'local';
}
class TemplateSelectModal extends Component {
  constructor(props) {
    super(props);
    this.handleOnMessage = ({
      payload: {
        type
      }
    }) => {
      if (type === 'UPDATE_SUCCESS') {
        window.location.reload();
      }
      if (type === 'UPDATE_ERROR') {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `swapTemplate.swapError.${this.props.contentType}`
          }),
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "swapTemplate.swapError.title"
          }),
          type: 'danger'
        });
      }
    };
    this.state = this.getModalSize();
    this.resizeModal = this.resizeModal.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.resizeModal);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeModal);
  }
  getModalSize() {
    return {
      width: WIDTH,
      height: Math.floor(document.documentElement.clientHeight - PADDING_TOP_BOTTOM * 2)
    };
  }
  resizeModal() {
    this.setState(this.getModalSize());
  }
  getContentCreatorUrl() {
    let url = `/content/${PortalIdParser.get()}/create/embedded-dialog`;
    if (!isSameHost()) {
      url = `${getHost()}${url}`;
    }
    return url;
  }
  render() {
    const {
      contentType,
      contentId,
      hasDndArea,
      onClose,
      previewKey,
      additionalTemplateTypeIds
    } = this.props;
    const {
      height,
      width
    } = this.state;
    return /*#__PURE__*/_jsx(ModalIFrame, {
      onClose: onClose,
      onReady: emptyFunction,
      onMessage: this.handleOnMessage,
      src: this.getContentCreatorUrl(),
      width: width,
      height: height,
      embeddedPassthruProps: {
        contentType,
        contentId,
        isChangeTemplateDialog: true,
        additionalTemplateTypeIds,
        hasDndArea,
        previewKey
      },
      iframePassthruProps: {
        id: 'template-swap-embed'
      }
    });
  }
}
TemplateSelectModal.propTypes = {
  contentType: PropTypes.string.isRequired,
  contentId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  hasDndArea: PropTypes.bool,
  previewKey: PropTypes.string,
  additionalTemplateTypeIds: PropTypes.arrayOf(PropTypes.number)
};
TemplateSelectModal.defaultProps = {
  hasDndArea: null
};
export default TemplateSelectModal;